import React from 'react';
import SectionLabel from '../components/SectionLabel';
import ContactForm from '../components/ContactForm';
import { useLang } from '../context/LanguageContext';
import { Mail, Phone, MapPin } from 'lucide-react';

export default function Contact() {
  const { t } = useLang();
  return (
    <div className="px-6 md:px-12 lg:px-16 py-16 md:py-24">
      <div className="max-w-[1200px] mx-auto">
        <SectionLabel>{t.sections.contact_us}</SectionLabel>
        <h1 className="mt-6 text-4xl md:text-5xl font-light tracking-tight">{t.nav.contact}</h1>
        <p className="mt-4 text-neutral-600 max-w-xl">{t.sections.contact_intro}</p>

        <div className="mt-14 grid lg:grid-cols-2 gap-16">
          <div className="space-y-8">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 border border-black flex items-center justify-center"><Mail className="w-4 h-4" /></div>
              <div>
                <p className="text-[11px] tracking-[0.25em] text-neutral-500">EMAIL</p>
                <a href="mailto:gestion@imargo.be" className="mt-1 block text-lg">gestion@imargo.be</a>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 border border-black flex items-center justify-center"><Phone className="w-4 h-4" /></div>
              <div>
                <p className="text-[11px] tracking-[0.25em] text-neutral-500">PHONE</p>
                <a href="tel:+3226441020" className="mt-1 block text-lg">02 644 10 20</a>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 border border-black flex items-center justify-center"><MapPin className="w-4 h-4" /></div>
              <div>
                <p className="text-[11px] tracking-[0.25em] text-neutral-500">{t.sections.find_us}</p>
                <p className="mt-1 text-lg">Avenue Louise 335<br />1050 Bruxelles, Belgique</p>
              </div>
            </div>
            <div className="aspect-[16/10] overflow-hidden">
              <iframe
                title="Imodeff location"
                src="https://www.google.com/maps?q=Avenue+Louise+335,+1050+Bruxelles&output=embed"
                className="w-full h-full border-0"
                loading="lazy"
              />
            </div>
          </div>
          <ContactForm />
        </div>
      </div>
    </div>
  );
}
